import React, { useState, useEffect } from "react";
import { useAuth } from "../auth/AuthContext";
import MonoButton from "./MonoButton";

const UpdateUserProfileModal = ({ initialData = {}, onSuccess, onClose }) => {
  const { userId } = useAuth();
  const [formData, setFormData] = useState({
    name: "",
    firstName: "",
    email: "",
    postalCode:"",
    address: "",
    city: "",
  });
  const [message, setMessage] = useState("");
  const [isSaved, setIsSaved] = useState(false);

  // Beim Öffnen des Modals Nutzerdaten laden
  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const res = await fetch(
          "https://www.denisbitter.de/stage01/api/get_user_profile.php",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ id: Number(userId) }),
          }
        );
        const data = await res.json();
        if (data.success) {
          setFormData(data.data);
          setMessage("");
        } else {
          setMessage("Fehler beim Laden der Daten: " + data.message);
        }
      } catch (err) {
        setMessage("Fehler beim Laden der Daten.");
        console.error(err);
      }
    };

    fetchUserData();
  }, [userId]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSave = async () => {
    try {
      const res = await fetch(
        "https://www.denisbitter.de/stage01/api/update_user_profile.php",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ ...formData, id: Number(userId) }),
        }
      );
      const data = await res.json();
      setMessage(data.message || "Aktualisiert.");
      if (data.success) {
        setMessage(data.message || "Aktualisiert.");
        setIsSaved(true);
        if (onSuccess) onSuccess();
        setTimeout(() => {
          if (onClose) onClose();
        }, 1500);
      } else {
        setMessage(data.message || "Fehler beim Speichern.");
      }
    } catch (err) {
      setMessage("Fehler beim Speichern.");
      console.error(err);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-[999]">
      <div className="bg-gradient-to-br from-gray-100 via-white to-gray-100/50  rounded-lg p-6 shadow-lg w-full max-w-md font-mono text-xs">
        <h2 className="text-xs font-bold mb-4 text-left">
          Benutzerdaten ändern
        </h2>
        <input
          type="text"
          name="firstName"
          value={formData.firstName}
          onChange={handleChange}
          className="border px-4 py-2 rounded w-full mb- text-xs"
          placeholder="Vorname"
        />
        <input
          type="text"
          name="name"
          value={formData.name}
          onChange={handleChange}
          className="border mt-2 px-4 py-2 rounded w-full  text-xs"
          placeholder="Nachname"
        />
        <input
          type="text"
          name="address"
          value={formData.address}
          onChange={handleChange}
          className="border mt-2 px-4 py-2 rounded w-full text-xs"
          placeholder="Straße"
        />
        <input
          type="text"
          name="postalcode"
          value={formData.postalCode}
          onChange={handleChange}
          className="border mt-2 px-4 py-2 rounded w-full text-xs"
          placeholder="PLZ"
        />
        <input
          type="text"
          name="city"
          value={formData.city}
          onChange={handleChange}
          className="border mt-2 px-4 py-2 rounded w-full text-xs"
          placeholder="Stadt"
        />
        <input
          type="email"
          name="email"
          value={formData.email}
          onChange={handleChange}
          className="border mt-2 px-4 py-2 rounded w-full text-xs"
          placeholder="E-Mail"
        />
        <MonoButton className="w-full mt-2" onClick={handleSave}>
          Speichern
        </MonoButton>
        {message && (
          <p className="text-sm mt-1 text-gray-600 break-words">{message}</p>
        )}
        <button
          className="mt-2 text-xs text-gray-400 underline w-full"
          onClick={onClose}
        >
          Abbrechen
        </button>
      </div>
    </div>
  );
};

export default UpdateUserProfileModal;
